import { render, staticRenderFns } from "./ButtonCheckboxRadio.vue?vue&type=template&id=4b6ebf52"
import script from "./ButtonCheckboxRadio.vue?vue&type=script&lang=js"
export * from "./ButtonCheckboxRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports